module.exports = __webpack_public_path__ + "static/media/13.d90c4f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/13.jpg
// module id = 81
// module chunks = 0